import './src/vaadin-rich-text-editor.js';
export * from './src/vaadin-rich-text-editor.js';
